import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CyTestDirective } from '@portal/directive';

@Component({
  selector: 'portal-ui-verification-failed',
  standalone: true,
  imports: [CyTestDirective],
  template: `<p portalCyTest="verification-failed">Verification Failed. Kindly try again.</p>`,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerificationFailedComponent {}
